import type { Role } from '@lentera/shared';

export interface NavItem {
  label: string;
  to: string;
  icon: string;
  roles?: Role[];
  children?: { label: string; to: string }[];
}

/**
 * Arsitektur informasi sesuai blueprint §3.
 *
 * "Database" (Domain 0) sengaja menjadi menu utama, bukan sub-menu Pengaturan:
 * itu data hidup yang paling sering dibuka di luar penilaian. Yang benar-benar
 * konfigurasi sekali-pakai berkumpul di "Pengaturan".
 */
export const NAV: NavItem[] = [
  { label: 'Beranda', to: '/', icon: '🏠' },
  {
    label: 'Database',
    to: '/database',
    icon: '🗂️',
    children: [
      { label: 'TBM', to: '/database/tbm' },
      { label: 'PELITA SLI', to: '/database/pelita' },
      { label: 'Kelas Intensif', to: '/database/kelas-intensif' },
    ],
  },
  {
    label: 'Pengukuran',
    to: '/pengukuran',
    icon: '📝',
    roles: ['super_admin', 'assessor'],
    children: [
      { label: 'Indeks TBM Berdaya', to: '/pengukuran/tbm' },
      { label: 'Kompetensi PELITA SLI', to: '/pengukuran/individu' },
      // Capaian Program ditunda dari versi 1.0 — lihat catatan di
      // apps/api/scripts/instruments.mjs.
    ],
  },
  {
    label: 'Monev',
    to: '/monev',
    icon: '🔍',
    children: [
      { label: 'Risalah', to: '/monev/risalah' },
      { label: 'Refleksi Program', to: '/monev/refleksi' },
    ],
  },
  {
    label: 'Analitik',
    to: '/analitik',
    icon: '📊',
    children: [
      { label: 'Rapor TBM', to: '/analitik/tbm' },
      { label: 'Rapor Individu', to: '/analitik/individu' },
      { label: 'Perbandingan & Tren', to: '/analitik/perbandingan' },
    ],
  },
  {
    label: 'Pengaturan',
    to: '/pengaturan',
    icon: '⚙️',
    roles: ['super_admin'],
    children: [
      { label: 'Instrumen & Bobot', to: '/pengaturan/instrumen' },
      { label: 'Periode Evaluasi', to: '/pengaturan/periode' },
      { label: 'Wilayah', to: '/pengaturan/wilayah' },
      { label: 'Pengguna & Penugasan', to: '/pengaturan/pengguna' },
    ],
  },
];

/** Bottom nav mobile — maksimal 5 item, sisanya masuk drawer "Lainnya". */
export const MOBILE_NAV = ['Beranda', 'Database', 'Pengukuran', 'Monev'] as const;

export function visibleNav(
  role: Role,
  individualId?: string | null,
  tbmId?: string | null,
): NavItem[] {
  if (role === 'pelita') {
    return [
      {
        label: 'Profil & Portofolio',
        to: individualId ? `/database/pelita/${individualId}` : '/database/pelita',
        icon: '👤',
      },
      {
        label: 'Kelas Intensif',
        to: '/kelas-intensif',
        icon: '🎓',
      },
      {
        label: 'Rapor Kompetensi',
        to: individualId ? `/analitik/individu?pelita=${individualId}` : '/analitik/individu',
        icon: '📊',
      },
      ...(tbmId
        ? [
            {
              label: 'Rapor TBM',
              to: `/analitik/tbm?tbm=${tbmId}`,
              icon: '🏫',
            },
          ]
        : []),
    ];
  }
  return NAV.filter((item) => !item.roles || item.roles.includes(role));
}
